module.exports = __webpack_public_path__ + "assets/img/homeTitle.79183c3b.svg";